import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function UserDashboard() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="body1">
          Welcome to your dashboard!
        </Typography>
      </Paper>
    </Box>
  );
}

export default UserDashboard;

